import classNames from 'classnames';

import styles from './Label.module.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}

const Label: React.FC<Props> = ({ className, children, prefix, suffix }) => (
  <label className={classNames(styles.wrapper, className)}>
    {prefix && <div className={styles.prefix}>{prefix}</div>}
    <div className={styles.title}>{children}</div>
    {suffix && <div className={styles.suffix}>{suffix}</div>}
  </label>
);

export default Label;
